export function determineColorCode(color: string | null): string {
  const colorMap: Record<string, string> = {
    'Black Red Stripe': 'BKRD-STR',
    'Black Sky-Gray Stripe': 'BKGR-STR',
    'Sky-Gray Black Stripe': 'GRBK-STR',
    'BKRD-STR': 'Black Red Stripe',
    bkrd: 'Black Red Stripe',
    'BKGR-STR': 'Black Sky-Gray Stripe',
    bkgr: 'Black Sky-Gray Stripe',
    'GRBK-STR': 'Sky-Gray Black Stripe',
    grbk: 'Sky-Gray Black Stripe',
    'BK-1TO': 'Black',
    'GR-1TO': 'Gray',
    bk: 'Black',
    gr: 'Gray',
    be: 'Beige',
    dg: 'Dark Gray',
    br: 'Brown',
    db: 'Dark Brown',
    wh: 'White',
    rd: 'Red',
    pk: 'Pink',
    wr: 'Wine Red',
    wlbk: 'Woodland Black',
    wlbe: 'Woodland Beige',
    wlgn: 'Woodland Green',
    gsbk: 'Grass Black',
    gsbr: 'Grass Brown',
  };
  // if (!color) {
  //   if (handle.includes('seat-covers')) {
  //     // TODO
  //   }
  //   else {
  //     const colorCode =
  //     return
  //   }
  // }
  return colorMap[color];
}

export function determineDisplayColor(productType: string, color1: string, color2: string): string {
  if (productType === 'Car Covers') {
    return `${color1} / ${color2}`;
  } else if (productType === 'Seat Covers') {
    return `${color1}`;
  } else {
    return `${color1}`;
  }
}
